// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j06e","col":"styles_col__2oNOF","actions":"styles_actions__w6EQ-","conflict":"styles_conflict__3sJ1n"};